var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C3.825 0 0 3.825 0 8.5C0 13.175 3.825 17 8.5 17C13.175 17 17 13.175 17 8.5C17 3.825 13.175 0 8.5 0ZM8.5 14.1667C5.38336 14.1667 2.83336 11.6167 2.83336 8.50007C2.83336 5.38342 5.38336 2.83336 8.5 2.83336C11.6166 2.83336 14.1666 5.38336 14.1666 8.5C14.1666 11.6166 11.6167 14.1667 8.5 14.1667Z",
    fill: "#518EF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49937 11.3337C10.0642 11.3337 11.3327 10.0652 11.3327 8.50035C11.3327 6.93553 10.0642 5.66699 8.49937 5.66699C6.93455 5.66699 5.66602 6.93553 5.66602 8.50035C5.66602 10.0652 6.93455 11.3337 8.49937 11.3337Z",
    fill: "#518EF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrent);
export default __webpack_public_path__ + "static/media/current.335272fbdbc351e6f0296f321a6f4546.svg";
export { ForwardRef as ReactComponent };